/* eslint-disable jsx-a11y/alt-text */
// src/pages/men/LazyImageWithLoader.js
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

export const LazyImageWithLoader = ({
  src,
  alt = "",
  width = 400,
  height = 500,
  sizes = "(max-width:768px) 80vw, (max-width:1200px) 33vw, 400px",
  srcSet,
  fetchPriority = "auto",
  className = "",
  style = {},
  eager = false,
  fadeMs = 180,
}) => {
  const [loaded, setLoaded] = useState(false);

  const imgStyle = {
    objectFit: "contain",
    width: "100%",
    height: "100%",
    display: "block",                 // prevents baseline gap (“bar” look)
    opacity: loaded ? 1 : 0,          // soft fade
    transition: `opacity ${fadeMs}ms ease-out`,
    ...style,
  };

  const common = {
    alt,
    width,
    height,
    sizes,
    ...(srcSet ? { srcSet } : {}),
    decoding: "async",
    style: imgStyle,
    className,
    onLoad: () => setLoaded(true),
  };

  if (eager) {
    return (
      <img
        src={src}
        loading="eager"
        {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
        {...common}
      />
    );
  }

  return (
    <LazyLoadImage
      src={src}
      loading="lazy"
      afterLoad={() => setLoaded(true)}
      {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
      {...common}
    />
  );
};
